import _ from 'lodash';
import { getApiConfig } from '../../../utilities';
import {loadingDialog_show} from '../../../actions/A_Popups';
import {store} from "../../../main";

let {get, post} = getApiConfig('BulkFeatureImport/');

export function importFeatures(data) {
  return post(data, 'Import');
}

export function getFeatures(fabricatorId, backupCategoriesOnly, backupWizardOnly, backupKitchen, backupBathroom, backupFireplace, backupLaundryroom, visualizerOnly, quotingToolOnly, backupFilters) {
  store.dispatch(loadingDialog_show(true, 'Generating Backup...', 'Generating backup of selected features, please be patient, this may take a few minutes...'));
  return get(`Export?fabricatorId=${fabricatorId}&backupCategoriesOnly=${backupCategoriesOnly}&backupWizardOnly=${backupWizardOnly}&backupKitchen=${backupKitchen}&backupBathroom=${backupBathroom}&backupFireplace=${backupFireplace}&backupLaundryroom=${backupLaundryroom}&visualizerOnly=${visualizerOnly}&quotingToolOnly=${quotingToolOnly}&backupFilters=${backupFilters}`)
    .then((response) => {
      store.dispatch(loadingDialog_show(false));
      return response;
    });
}